import { useQuery } from '@tanstack/react-query';

import partService from 'services/partService';

export default function useCostingVariablesData({
  interrogationFileId,
  queryParams,
  materialId,
}) {
  return useQuery(
    ['costingVariablesData', interrogationFileId, queryParams, materialId],
    () => partService.getCostingVariablesData(interrogationFileId, queryParams),
  );
}
